<template>
  <div>
    <div class="container-alb filter-mobile">
      <form
        autocomplete="off"
        @submit.prevent="searchBeneficiaries()"
      >
        <table
          cellpadding="10"
          cellspacing="0"
          width="95%"
          class="hover-table"
          align="center"
        >
          <tr>
            <td>
              {{ $t("title.beneficiariesTableCNP") }}
              <input
                type="text"
                class="formedituser"
                v-model="filters.cnp"
              />
            </td>
            <td>
              {{ $t("title.lastNameLabel") }}
              <input
                type="text"
                class="formedituser"
                v-model="filters.last_name"
              />
            </td>
            <td>
              {{ $t("title.firstNameLabel") }}
              <input
                type="text"
                class="formedituser"
                v-model="filters.first_name"
              />
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("title.emailField") }}
              <input
                type="text"
                class="formedituser"
                v-model="filters.email"
              />
            </td>
            <td>
              {{ $t("title.mobileField") }}
              <input
                type="text"
                id="beneficiaryMobilePhone"
                v-model="filters.phone"
                class="formedituser"
              />
            </td>
            <td>
              {{ $t("title.companyNameLabel") }}
              <input
                type="text"
                id="beneficiaryCompanyName"
                v-model="filters.customer_name"
                class="formedituser"
              />
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="submit"
                class="notification-action custom-notification-action border-0"
              >
                {{ $t("title.searchButtonLabel") }}
              </button>
            </td>
          </tr>
        </table>
      </form>
    </div>

    <!-- ... existing code ... -->
    <div class="container-alb">
      <!-- <div class="table-header-wrapper">
        <div class="left">
          <h3 class="table-title d-inline-block">
            {{ $t("beneficiariesName") }}
          </h3>
           <img
            class="download d-inline-block"
            @click="getExcelTransaction()"
            src="@/assets/images/download.svg"
          /> --
        </div>
      </div> -->
      <br/>

      <BeneficiariesTable
        :beneficiaries="this.beneficiariesList"
        @change="sortBy(sortField, sortDirection)"
      />

      <div
        class="error-wrapper border-box"
        v-if="this.beneficiariesList && this.beneficiariesList.length === 0"
      >
        <p>{{ $t("title.noBeneficiariesInfoMessage") }}</p>
      </div>

      <div class="error-wrapper border-box" v-if="this.transactionError">
        <p>{{ $t("title.errorTransactionMessage") }}</p>
      </div>

      <div class="pagination-wrapper border-box">
        <b-pagination
          v-model="currentPage"
          :total-rows="beneficiariesCount"
          :per-page="perPage"
          size="sm"
        ></b-pagination>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_info', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg"/>
        </a>
        <div v-if="this.error">
          <p v-html="$t('title.errorActionBeneficiary_' + this.error.code)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BeneficiariesTable from "@/components/company/beneficiaries-support/BeneficiariesTable.vue";
import utils from "@/plugins/utils.js";

import httpServiceBenef from "@/http/http-ben-support.js";
import {BPagination} from "bootstrap-vue-3";
import Cookies from "js-cookie";
import {saveAs} from "file-saver";
import validator from "@/plugins/fieldValidation.js";

export default {
  props: {
    msg: String,
  },
  components: {
    BeneficiariesTable,
    "b-pagination": BPagination,
  },
  data() {
    return {
      transactionError: null,
      beneficiariesList: [],
      tempInvoices: null,
      filters: {
        // product: 11,
        cnp: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        customer_name: "",
      },
      beneficiariesCount: 10,
      perPage: 10,
      currentPage: 1,
      sortField: "hd1name",
      sortDirection: "asc",
      selectedProduct: null,
      error: null,
      config: JSON.parse(sessionStorage.getItem("client_jsonFile")),
    };
  },
  methods: {
    productSelected(event) {
      this.filters.product = event.target.value;
      this.searchBeneficiaries();
    },
    isSelectedProduct(product) {
      return product === this.filters.product;
    },
    sortBy(sortField, sortDirection, status) {
      this.sortField = sortField;
      this.sortDirection = sortDirection;
      this.searchBeneficiaries(status);
    },
    showModalPopup(elementId, show) {
      if (show) {
        document.getElementById(elementId).style.visibility = "visible";
      } else {
        document.getElementById(elementId).style.visibility = "hidden";
      }
    },
    searchBeneficiaries() {
      this.error = null;

      let beneficiariesFilter =
        "?per_page=" + this.perPage +
        "&page=" + this.currentPage +
        "&sort=" + this.sortDirection;

      if (this.filters.cnp.trim().length > 0) {
        beneficiariesFilter += "&cnp=" + this.filters.cnp;
      }
      if (this.filters.email.trim().length > 0) {
        beneficiariesFilter += "&email=" + this.filters.email;
      }
      if (this.filters.phone.trim().length > 0) {
        beneficiariesFilter += "&phone=" + this.filters.phone;
      }
      if (this.filters.first_name.trim().length > 0) {
        beneficiariesFilter += "&first_name=" + this.filters.first_name.toUpperCase();
      }
      if (this.filters.last_name.trim().length > 0) {
        beneficiariesFilter += "&last_name=" + this.filters.last_name.toUpperCase();
      }
      if (this.filters.customer_name.trim().length > 0) {
        beneficiariesFilter += "&customer_name=" + this.filters.customer_name;
      }
      if (this.sortDirection === "desc") {
        beneficiariesFilter += "&desc=" + this.sortField;
      } else {
        beneficiariesFilter += "&asc=" + this.sortField;
      }
      this.showModalPopup("modal_popup_loading", true);

      httpServiceBenef.beneficiariesService
        .searchBeneficiaries(beneficiariesFilter, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          return error.response;
        })
        .then((response) => {
          if (response.status === 200) {
            this.beneficiariesList = response.data;
            this.beneficiariesCount = parseInt(response.headers["x-up-count"]);
          } else if (response.status === 400) {
            this.error = {code: response.data.error_code};
          } else {
            this.error = {code: response.error_code};
          }
          if (this.error) {

            this.showModalPopup("modal_popup_info", true);
          }
          this.showModalPopup("modal_popup_loading", false);
        })

    },
    selectProduct(index) {
      this.selectedProduct = this.cardProducts[index];
    },
    getExcelTransaction() {
      this.showModalPopup("modal_popup_loading", true);

      var beneficiariesFilter =
        "?product=" +
        this.filters.product +
        (this.filters.cnp.trim().length > 0
          ? "&cnp=" + this.filters.cnp
          : "") +
        (this.filters.affiliate_name.trim().length > 0
          ? "&name=" + this.filters.affiliate_name
          : "") +
        (this.filters.username.trim().length > 0
          ? "&username=" + this.filters.username
          : "") +
        (this.filters.first_name.trim().length > 0
          ? "&first_name=" + this.filters.first_name
          : "") +
        (this.filters.last_name.trim().length > 0
          ? "&last_name=" + this.filters.last_name
          : "");
      beneficiariesFilter +=
        "&per_page=" + 100000 + "&page=" + 1 + "&sort=" + this.sortDirection;
      if (this.sortDirection === "desc") {
        beneficiariesFilter += "&desc=" + this.sortField;
      } else {
        beneficiariesFilter += "&asc=" + this.sortField;
      }

      return httpServiceBenef.beneficiariesService
        .getTransactionFile(beneficiariesFilter, Cookies.get("token"))
        .then((response) => {
          if (response.status === 200) {
            var blob = new Blob(
              [utils.base64ToArrayBuffer(response.data.content)],
              {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetapplication/vnd.ms-excel",
              }
            );
            saveAs(blob, response.data.name);
          } else if (response.status === 400 || response.status === 403) {
            this.transactionError = {code: 500};
          } else {
            this.transactionError = {code: 500};
          }
          this.showModalPopup("modal_popup_loading", false);
        })
        .catch((error) => {
          this.transactionError = {code: 500};
          this.showModalPopup("modal_popup_loading", false);
        });
    },
  },
  // computed: {
  //   cardProducts() {
  //     let cardProducts = [];
  //     for (let index in this.config.products) {
  //       if (this.config.products[index].card > 0) {
  //         cardProducts.push(this.config.products[index]);
  //       }
  //     }
  //     return cardProducts;
  //   },
  // },
  mounted() {
    Cookies.remove("selectedBeneficiary");
    // this.filters.product = this.config.products[0].card;
    // this.beneficiariesList = this.searchBeneficiaries();
  },
  created() {
  },
  watch: {
    currentPage: function () {
      this.searchBeneficiaries();
    },
  },
};
</script>

<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
.page-link {
  color: #4a4a4a;
}

.page-link:hover {
  color: #4e5b59;
}

.page-item.active .page-link {
  background-color: #4e5b59 !important;
  border-color: #4e5b59 !important;
}

.invoices-filter .reportrange-text {
  height: 27px;
  font-size: 13px;
  padding: 3px 10px;
  border: none !important;
  color: #585858;
  background: #f1f1f1;
}
</style>
